// LiCardLoader.js
import React from "react";


const LiCardLoader = () => {
  return (
    <div className="li-card-loader">
      
      <div className="li-text-skeleton li-title"></div>
      <div className="li-text-skeleton li-subtitle"></div>
      <div className="li-text-skeleton"></div>
    </div>
  );
};

export default LiCardLoader;
